module.exports = __webpack_public_path__ + "img/16.5ae9ab8.jpg";